import React,{useState,useEffect} from 'react';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { ConfiguracionColumnasUsuarioScreen } from './screen';

export const ConfiguracionColumnasUsuarioContainer= (props) =>{

    const {user} = props
    const api = new UsuariosAdapter();
    const {resultError, exceptionError, launchNotification} = useNotifications();
    const [ config, setConfig ] = useState(undefined);
    // let [isLoading, setIsLoading] = useState(false)
    let result;
  
    useEffect(() => {getColumnasConfig()}, []);
  
    const getColumnasConfig = async () => {
      try {
        result = await api.GetColumnasUsuario();
        if(result.data && result.data!=="")
        {
          setConfig(result.data[0] || undefined);
        }else{resultError()}
      } catch (error) {
        let exception = ServerErrorMessage(error);
        exceptionError(exception)
      }
    };

    const SaveConfigColumn = async (columnas) => {
      try {
        result = await api.GuardarColumnasUsuario(columnas);
        if(result.data && result.data!=="")
        {
          setConfig(result.data[0] || undefined);
          launchNotification({type:"success",title:"Configuración Columnas",message:"Se han configurado columnas de una pantalla."})
        }else{resultError()}
      } catch (error) {
        let exception = ServerErrorMessage(error);
        exceptionError(exception)
      }
    };


    return <ConfiguracionColumnasUsuarioScreen data={config&&config.columnas} onSave={SaveConfigColumn} user={user}/>
 
}
export default ConfiguracionColumnasUsuarioContainer;